import toast from "react-hot-toast";
import { useAuth } from "../../../utils/AuthContext";
import useAddress from "../../userDashboard/address/useAddress";
import useUserBundle from "../bundle/userbundle/useUserBundle";
import useOrders from "../../userDashboard/orders/useOrders";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function useBundleLogic(productId) {
  const history = useHistory();
  const {
    bundles,
    isLoading,
    error,
    productBundles,
    errorGettingProductBundles,
    isGettingProductBundles,
  } = useUserBundle(productId);

  const {
    createOrderFn,
    clearCartFn,
    setIsModal,
    setOrderSuccess,
    isCreatingOrder,
  } = useOrders();
  const [orderId, setOrderId] = useState();

  const { isLoggedIn } = useAuth();
  const { addresses } = useAddress();
  const defaultAddress = addresses?.find(
    (address) => address.isDefault === true
  );
  //   console.log("products bundle: ", bundles);

  const calculateBundlePrice = () => {
    const totalOriginalPrice = bundles[0].products.reduce((total, prod) => {
      return total + prod?.product?.price * prod?.quantity;
    }, 0);

    let discountedPrice = totalOriginalPrice;
    if (bundles[0].discountType === "percentage") {
      discountedPrice =
        totalOriginalPrice -
        (totalOriginalPrice * bundles[0].discountValue) / 100;
    } else {
      discountedPrice = totalOriginalPrice - bundles[0].discountValue;
    }

    return {
      original: totalOriginalPrice,
      discounted: Math.max(discountedPrice, 0),
    };
  };
  const handleCreateOrder = async (selectedAddressId) => {
    const selectedAddress =
      addresses?.find((addr) => (addr.id || addr._id) === selectedAddressId) ||
      defaultAddress;
    if (!selectedAddress) {
      toast.error("Please select or add a delivery address");
      return;
    }

    const amount = calculateBundlePrice().discounted;

    // resolve products with categories
    const productsWithCategories = bundles[0].products;
    // await Promise.all(
    // cartItems?.items;

    //   ?.map(async (item) => {
    //     const product = await getOneProductFn(item.productId);
    //     return {
    //       ...item,
    //       category: product?.category || null,
    //     };
    //   }) || []
    // );
    const orderData = {
      amount: amount,
      address: selectedAddress.id || selectedAddress._id,
      products: productsWithCategories,
    };
    createOrderFn(orderData, {
      onSuccess: (data) => {
        history.push("/user/dashboard/orders");
        // clearCartFn();
        // setOrderId(data?.order?._id || data?._id);
        // setOrderSuccess(true);
        // setIsModal(false);
      },
    });
  };
  return {
    // BUNDLES DATA
    bundles,
    isLoadingBundles: isLoading,
    errorGettingBundles: error,
    productBundles,
    errorGettingProductBundles,
    isGettingProductBundles,
    // IS LOGGED IN STATUS
    isLoggedIn,
    // ADDRESSES
    addresses,
    // CREATE BUNDLE ORDER
    handleCreateOrder,
    calculateBundlePrice,
    isCreatingOrder,
  };
}

export default useBundleLogic;
